import { useEffect } from 'react';

const DEFAULT_TITLE = 'YuHasPro — Admissions CRM for Coaching Classes & Institutes in India';
const DEFAULT_DESC = 'Manage leads, admissions, fees, and multi-branch operations from one platform. Built for coaching classes, schools, and education franchises across India.';

export function useSEO({ title, description }) {
  useEffect(() => {
    document.title = title;
    const setMeta = (selector, content) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute('content', content);
    };
    setMeta('meta[name="description"]', description);
    setMeta('meta[property="og:title"]', title);
    setMeta('meta[property="og:description"]', description);
    setMeta('meta[property="og:url"]', window.location.origin + window.location.pathname);
    setMeta('meta[name="twitter:title"]', title);
    setMeta('meta[name="twitter:description"]', description);

    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', window.location.origin + window.location.pathname);

    return () => {
      document.title = DEFAULT_TITLE;
      setMeta('meta[name="description"]', DEFAULT_DESC);
    };
  }, [title, description]);
}
